import { useTranslation } from 'react-i18next'

import { NameDto } from '../../../model/NameDto'
import { RebateApprovalPeriod, RebateApprovalType } from '../../../model/RebateGroupsDto'

export const useTranslatedRebateOptions = (): {
  translateApprovalTypes: {
    (options: NameDto[]): NameDto<RebateApprovalType>[]
    (options: NameDto): NameDto<RebateApprovalType>
  }
  translatePeriods: {
    (options: NameDto[]): NameDto<RebateApprovalPeriod>[]
    (options: NameDto): NameDto<RebateApprovalPeriod>
  }
} => {
  const { t } = useTranslation()

  const translateApprovalType = (option: NameDto): NameDto<RebateApprovalType> => {
    switch (option.id) {
      case RebateApprovalType.Manual:
        return {
          ...option,
          name: t('IB.RebatesPage.GroupsPage.Manual'),
        }
      case RebateApprovalType.Auto:
        return {
          ...option,
          name: t('IB.RebatesPage.GroupsPage.Automatic'),
        }
      default:
        return option
    }
  }

  function translateApprovalTypes(options: NameDto[]): NameDto<RebateApprovalType>[]
  function translateApprovalTypes(options: NameDto): NameDto<RebateApprovalType>
  function translateApprovalTypes(options: NameDto | NameDto[]) {
    if (Array.isArray(options)) {
      return options.map(translateApprovalType)
    }
    return translateApprovalType(options)
  }

  const translatePeriod = (option: NameDto): NameDto<RebateApprovalPeriod> => {
    switch (option.id) {
      case RebateApprovalPeriod.Weekly:
        return {
          ...option,
          name: t('IB.RebatesPage.GroupsPage.Weekly'),
        }
      case RebateApprovalPeriod.Every2Weeks:
        return {
          ...option,
          name: t('IB.RebatesPage.GroupsPage.Every 2 weeks'),
        }
      case RebateApprovalPeriod.Monthly:
        return {
          ...option,
          name: t('IB.RebatesPage.GroupsPage.Monthly'),
        }
      default:
        return option
    }
  }

  function translatePeriods(options: NameDto[]): NameDto<RebateApprovalPeriod>[]
  function translatePeriods(options: NameDto): NameDto<RebateApprovalPeriod>
  function translatePeriods(options: NameDto | NameDto[]) {
    if (Array.isArray(options)) {
      return options.map(translatePeriod)
    }
    return translatePeriod(options)
  }

  return {
    translateApprovalTypes,
    translatePeriods,
  }
}
